/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type AdminPage_viewer$ref = any;
export type AdminPage_QueryVariables = {};
export type AdminPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": AdminPage_viewer$ref;
    }) | null;
};
export type AdminPage_Query = {
    readonly response: AdminPage_QueryResponse;
    readonly variables: AdminPage_QueryVariables;
};



/*
query AdminPage_Query {
  viewer {
    id
    ...AdminPage_viewer
  }
}

fragment AdminPage_viewer on Viewer {
  id
  ...AdminDonationsPage_viewer
  user {
    id
    accountRole {
      accountRoleTitle
      id
    }
    permissions {
      id
      oneCommerce {
        id
        superAdmin {
          access
        }
      }
    }
  }
}

fragment AdminDonationsPage_viewer on Viewer {
  user {
    id
    userId
    email
    permissions {
      id
      oneCommerce {
        id
        superAdmin {
          access
        }
      }
    }
    donations(first: 100, sortBy: "any", status: ["submitted"], typesToInclude: ["event", "preferredCustomer"], skipCount: 0, fetchCount: 100, sortColumn: "donationCreateDate", sortDirection: false) {
      edges {
        node {
          id
          donationId
          status
          npoId
          orderCount
          ordersSubTotal
          donationAmount
          donationType
          submittedDate
          eventId
          orderDonationAmount
          ordersSubTotalAmount
          donationAmountOverride
          expectedCheckDeliveryDate
          lobTrackingCarrier
          lobTrackingNumber
          account {
            fullName
            id
          }
          event {
            id
            trinityPartyId
            hostKitQuantity
            hostFullName
            hostKitOrderNumbers
          }
          nonProfit {
            id
            nonProfitId
            nonProfitName
            nonProfitTaxId
            nonProfitAddress {
              optionalName
              addressLineOne
              addressLineTwo
              city
              state
              zip
              phoneNumber
            }
          }
          checkImageUrl
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "Literal",
            "name": "fetchCount",
            "value": 100,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "skipCount",
            "value": 0,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "sortBy",
            "value": "any",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "sortColumn",
            "value": "donationCreateDate",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "sortDirection",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "status",
            "value": [
                "submitted"
            ],
            "type": "[String]"
        } as any),
        ({
            "kind": "Literal",
            "name": "typesToInclude",
            "value": [
                "event",
                "preferredCustomer"
            ],
            "type": "[String]"
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "AdminPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "AdminPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "AdminPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "userId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "superAdmin",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "access",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "donations",
                                    "storageKey": "donations(fetchCount:100,first:100,skipCount:0,sortBy:\"any\",sortColumn:\"donationCreateDate\",sortDirection:false,status:[\"submitted\"],typesToInclude:[\"event\",\"preferredCustomer\"])",
                                    "args": (v1 /*: any*/),
                                    "concreteType": "DonationConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "DonationEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Donation",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderDonationAmount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "status",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "npoId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderCount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ordersSubTotal",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "donationAmount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "donationType",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "submittedDate",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "eventId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "donationId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ordersSubTotalAmount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "donationAmountOverride",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "expectedCheckDeliveryDate",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "lobTrackingCarrier",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "lobTrackingNumber",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "account",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "fullName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "event",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "trinityPartyId",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hostKitQuantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hostFullName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hostKitOrderNumbers",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "nonProfit",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "NonProfit",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "nonProfitId",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "nonProfitName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "nonProfitTaxId",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "nonProfitAddress",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "NonProfitAddress",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "optionalName",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "addressLineOne",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "addressLineTwo",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "city",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "state",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "zip",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "phoneNumber",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "checkImageUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "cursor",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "endCursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": null,
                                    "name": "donations",
                                    "args": (v1 /*: any*/),
                                    "handle": "connection",
                                    "key": "Donations_donations",
                                    "filters": [
                                        "sortBy",
                                        "status",
                                        "typesToInclude",
                                        "skipCount",
                                        "fetchCount",
                                        "sortColumn",
                                        "sortDirection"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "accountRole",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AccountRoleType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "accountRoleTitle",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "AdminPage_Query",
            "id": null,
            "text": "query AdminPage_Query {\n  viewer {\n    id\n    ...AdminPage_viewer\n  }\n}\n\nfragment AdminPage_viewer on Viewer {\n  id\n  ...AdminDonationsPage_viewer\n  user {\n    id\n    accountRole {\n      accountRoleTitle\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        superAdmin {\n          access\n        }\n      }\n    }\n  }\n}\n\nfragment AdminDonationsPage_viewer on Viewer {\n  user {\n    id\n    userId\n    email\n    permissions {\n      id\n      oneCommerce {\n        id\n        superAdmin {\n          access\n        }\n      }\n    }\n    donations(first: 100, sortBy: \"any\", status: [\"submitted\"], typesToInclude: [\"event\", \"preferredCustomer\"], skipCount: 0, fetchCount: 100, sortColumn: \"donationCreateDate\", sortDirection: false) {\n      edges {\n        node {\n          id\n          donationId\n          status\n          npoId\n          orderCount\n          ordersSubTotal\n          donationAmount\n          donationType\n          submittedDate\n          eventId\n          orderDonationAmount\n          ordersSubTotalAmount\n          donationAmountOverride\n          expectedCheckDeliveryDate\n          lobTrackingCarrier\n          lobTrackingNumber\n          account {\n            fullName\n            id\n          }\n          event {\n            id\n            trinityPartyId\n            hostKitQuantity\n            hostFullName\n            hostKitOrderNumbers\n          }\n          nonProfit {\n            id\n            nonProfitId\n            nonProfitName\n            nonProfitTaxId\n            nonProfitAddress {\n              optionalName\n              addressLineOne\n              addressLineTwo\n              city\n              state\n              zip\n              phoneNumber\n            }\n          }\n          checkImageUrl\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'db0d72a9e68c12fd5da744bed76df8c4';
export default node;
